import * as React from "react";
import { Modal, Button, Input, Cascader, DatePicker, InputNumber, Select, message } from "antd";
import { connect } from "react-redux";
// 订单来源级联
import { getFromSource, getSkuUnit } from "utils/interface";
import moment from "moment";
import { CQ } from "utils/commonQuest";
const { TextArea } = Input;
const Option = Select.Option;

interface IAddorderProps {
  id: any;
  email: any;
  goTime: any;
  skuName: any;
  contact: any;
  containerBody?: any;
  tianmaoCode: any;
  taoAccount: any;
  mallAccount: any;
  skuId: any;
  addOrder: any;
  fromSourceFrist: any;
  fromSourceSecond: any;
  getMoneyCode: any;
}
// 异步请求接口，阻塞进程获取数据后执行回调函数

async function getData(callback, id = 0, type = "first", first = '') {
  id = type === "first" ? 0 : id;
  const data = await CQ(
    getFromSource({
      id: id
    })
  );

  const data2 = await CQ(
    getFromSource({
      id: first
    })
  );

  const _data = data.map(item => {
    let _data = {
      label: item.name,
      value: String(item.id)
    };
    if (type === "first") {
      _data["isLeaf"] = false;
    }
    if (first && String(item.id) == first) {
      _data["children"] = data2.map(item2 => {
        return {
          label: item2.name,
          value: String(item2.id)
        };
      });
    }
    return _data;
  });
  callback && callback(_data);
}

async function getSku(callback, tmall_code = '', search = '') {
  const data = await CQ(
    getSkuUnit({
      search: search,
      tmall_code: tmall_code,
    })
  );
  callback && callback(data);
}

// 新增订单
class Addorder extends React.Component<IAddorderProps, any> {
  state = {
    visible: false,
    options: [],
    first: "91",
    second: "3",
    data: [],
    skuName: '',
    tianmaoCode: '',
    skuId: '',
    taoAccount: '',
    mallAccount: '',
    add_why: '5',
    add_remark: '其他',
    payment: '',
    price: '',
    adult_price: '',
    child_price: '',
    baby_price: '',
    num: 0,
    adult_num: 0,
    children_num: 0,
    baby_num: 0,
    num_selected: 0,
    adult_selected: 0,
    child_selected: 0,
    baby_selected: 0,
    sku_date: '',
    money_code: '',
  };

  constructor(props: IAddorderProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if (prevState.skuName != nextProps.skuName) {
      this.setState({
        skuName: this.props.skuName,
        tianmaoCode: this.props.tianmaoCode,
        taoAccount: this.props.taoAccount,
        mallAccount: this.props.mallAccount,
        skuId: this.props.skuId,
        second: this.props.fromSourceSecond,
        first: this.props.fromSourceFrist,
      });
      return false;
    }
    return true;
  }

  // 加载二级数据
  loadData = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    if (targetOption.loading) return;
    targetOption.loading = true;
    getData(
      _data => {
        const children = _data;
        targetOption.loading = false;
        targetOption.children = children;
        this.setState({
          options: [...this.state.options]
        });
      },
      targetOption.value,
      "second"
    );
  };

  addOrder = () => {
    console.log(this.state.sku_date)
    const param: any = {
      old_id: this.props.id,
      from_source_details: this.state.second,
      mall_account: this.state.mallAccount,
      tao_account: this.state.taoAccount,
      num: this.state.num,
      adult_num: this.state.adult_num,
      children_num: this.state.children_num,
      baby_num: this.state.baby_num,
      add_why: this.state.add_why,
      link_ids: [],
      add_remark: this.state.add_remark,
      price: this.state.price,
      adult_price: this.state.adult_price,
      child_price: this.state.child_price,
      baby_price: this.state.baby_price,
      payment: this.state.payment,
      sku_date: this.state.sku_date,
      sku_id: this.state.skuId,
      from_source: this.state.first,
    };
    this.props.addOrder({
      ...param,
      callback: (data) => {
        if (typeof data != 'object') {
          message.info("新增成功，准备跳转....");
          setTimeout(() => {
            window.location.href = '/app/orderDetails/' + data;
          }, 100);
        }
      }
    });
  }

  getContainer = () => {
    const containerBody = this.props.containerBody;
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  filter = (inputValue, path) => {
    return path.some(
      option =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }

  show(id) {
    this.setState({
      visible: true
    })
    const param: any = {
      id: this.props.id,
    }
    this.props.getMoneyCode({
      ...param,
      callback: (data) => {
        this.setState({
          money_code: data,
        });
      }
    })
    getSku(data => {
      this.setState({
        data: data
      });
      for (var key in data) {
        if (data[key]['sku_id'] == this.state.skuId) {
          this.setState({
            num_selected: data[key]['num_selected'],
            adult_selected: data[key]['adult_selected'],
            child_selected: data[key]['child_selected'],
            baby_selected: data[key]['baby_selected'],
          });
          break;
        }
      }

    }, this.props.tianmaoCode);
    getData(data => {
      this.setState({
        options: data
      });
    }, 0, "first", this.state.first);
  }


  onChange = value => {
    console.log(value);
    if (value.length == 2) {
      this.setState({
        first: value[0],
        second: value[1],
      });
    } else {
      this.setState({
        first: value[0],
        second: value[0],
      });
    }
  };

  onChangeDate = (name, date, dateString) => {
    if (name == 'sku_date') {
      this.setState({
        sku_date: dateString
      })
    }
  }

  change = (name, value) => {
    if (name == 'taoAccount') {
      this.setState({
        taoAccount: value.target.value
      })
    } else if (name == 'mallAccount') {
      this.setState({
        mallAccount: value.target.value
      })
    } else if (name == 'mallAccount') {
      this.setState({
        mallAccount: value.target.value
      })
    } else if (name == 'payment') {
      this.setState({
        payment: value.target.value
      })
    } else if (name == 'add_remark') {
      this.setState({
        add_remark: value.target.value
      })
    } else if (name == 'add_why') {
      this.setState({
        add_why: value
      })
    } else if (name == 'num') {
      this.setState({
        num: value
      })
    } else if (name == 'price') {
      this.setState({
        price: value.target.value
      })
    } else if (name == 'adult_num') {
      this.setState({
        adult_num: value
      })
    } else if (name == 'child_price') {
      this.setState({
        child_price: value.target.value
      })
    } else if (name == 'baby_num') {
      this.setState({
        baby_num: value
      })
    } else if (name == 'baby_price') {
      this.setState({
        baby_price: value.target.value
      })
    } else if (name == 'adult_price') {
      this.setState({
        adult_price: value.target.value
      })
    } else if (name == 'children_num') {
      this.setState({
        children_num: value
      })
    } else if (name == 'skuId') {
      this.setState({
        skuId: value
      })
      this.state.data.map((item, key) => {
        if (item['sku_id'] == value) {
          this.setState({
            num_selected: item['num_selected'],
            adult_selected: item['adult_selected'],
            child_selected: item['child_selected'],
            baby_selected: item['baby_selected'],
          })
        }
      })
    } else if (name == 'sku_date') {
      console.log(value)
      this.setState({
        sku_date: value.value
      })
    }
  }
  getSearch = (value) => {
    getSku(data => {
      this.setState({
        data: data
      });
    }, '', value);
  }

  getOption = () => {
    const listItems = this.state.data.map((item, key) => {
      return (<Option key={key} value={item['sku_id']}>{item['name']}</Option>);
    })
    return (
      listItems
    )
  }

  render() {
    const Datetime = moment(this.state.sku_date, 'YYYY-MM-DD HH:mm:ss');
    console.log(this.state.skuId);
    return (
      <React.Fragment>
        <Button onClick={this.show.bind(this, this.props.id)}>新增订单</Button>
        <Modal maskClosable={false} onCancel={this.handleCancel} title="新增订单" visible={this.state.visible} footer={null} width="auto" centered={true}>
          <div className="wechat-push">
            <div className="hang"><label className="f">选择SKU：</label><span>
              <Select onChange={this.change.bind(this, 'skuId')} showSearch value={this.state.skuId} className="messge" onSearch={this.getSearch} >
                {this.getOption()}
              </Select>
            </span></div>
            <div className="hang"><label className="f">出发日期：</label><span>{this.state.sku_date ? <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" value={Datetime} onChange={this.onChangeDate.bind(this, 'sku_date')} className="messge" /> : <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" onChange={this.onChangeDate.bind(this, 'sku_date')} className="messge" />}</span></div>
            <div className="hang"><label className="f">订单来源：</label><span><Cascader value={[this.state.first, this.state.second]} options={this.state.options} className="messge" loadData={this.loadData} onChange={this.onChange} style={{ width: 220 }} changeOnSelect={true} showSearch={{ filter: this.filter }} placeholder="订单来源" getPopupContainer={this.getContainer} /></span></div>
            <div className="hang"><label className="f">淘宝账号：</label><span><Input value={this.state.taoAccount} onChange={this.change.bind(this, 'taoAccount')} className="messge" /></span></div>
            <div className="hang"><label className="f">商城账号：</label><span><Input value={this.state.mallAccount} onChange={this.change.bind(this, 'mallAccount')} className="messge" /></span></div>
            <div className="hang"><label className="f">售卖单位：</label><div className="sale">
              <div className="price_num">
                <div className='h_name'>
                  <span className='span_left'>价格</span>
                  <span>数量</span>
                </div>
                <ul>
                  {this.state.num_selected == 1 ? <li><span className='name'>数量</span><Input placeholder={this.state.money_code} value={this.state.price} onChange={this.change.bind(this, 'price')} className="sale_input" /><InputNumber value={this.state.num} min={0} onChange={this.change.bind(this, 'num')} className="sale_input" /></li> : ''}
                  {this.state.adult_selected == 1 ? <li><span className='name'>成人</span><Input placeholder={this.state.money_code} value={this.state.adult_price} onChange={this.change.bind(this, 'adult_price')} className="sale_input" /><InputNumber value={this.state.adult_num} min={0} onChange={this.change.bind(this, 'adult_num')} className="sale_input" /></li> : ''}
                  {this.state.child_selected == 1 ? <li><span className='name'>儿童</span><Input placeholder={this.state.money_code} value={this.state.child_price} onChange={this.change.bind(this, 'child_price')} className="sale_input" /><InputNumber value={this.state.children_num} min={0} onChange={this.change.bind(this, 'children_num')} className="sale_input" /></li> : ''}
                  {this.state.baby_selected == 1 ? <li><span className='name'>婴儿</span><Input placeholder={this.state.money_code} value={this.state.baby_price} onChange={this.change.bind(this, 'baby_price')} className="sale_input" /><InputNumber value={this.state.baby_num} min={0} onChange={this.change.bind(this, 'baby_num')} className="sale_input" /></li> : ''}

                </ul>
              </div>
            </div></div>
            <div className="hang"><label className="f">实付金额：</label><span><Input value={this.state.payment} onChange={this.change.bind(this, 'payment')} className="price" /> ({this.state.money_code})</span></div>
            <div className="hang"><label className="f">添加原因：</label><span>
              <Select onChange={this.change.bind(this, 'add_why')} value={this.state.add_why} showSearch className="messge" placeholder="请选择添加原因"  >
                <Option value="1">促销</Option>
                <Option value="2">售后赔付</Option>
                <Option value="3">退订未退款</Option>
                <Option value="4">线下订单</Option>
                <Option value="5">其它</Option>
                <Option value="6">大客户</Option>
                <Option value="7">分销</Option>
                <Option value="8">渠道</Option>
                <Option value="9">招待专用</Option>
                <Option value="10">行程更改</Option>
                <Option value="11">订单拆分</Option>
                <Option value="12">结算专用</Option>
              </Select>
            </span></div>
            <div className="hang"><label className="f">详情：</label><span><TextArea value={this.state.add_remark} onChange={this.change.bind(this, 'add_remark')} rows={3} /></span></div>
          </div>
          <div className="down-confirmation">
            <Button type="primary" onClick={this.addOrder} >提交</Button>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  skuId: state.orderDetails.skuId,
  skuName: state.orderDetails.skuName,
  goTime: state.orderDetails.goTime,
  email: state.orderDetails.email,
  contact: state.orderDetails.contact,
  taoAccount: state.orderDetails.taoAccount,
  mallAccount: state.orderDetails.mallAccount,
  tianmaoCode: state.orderDetails.tianmaoCode,
  fromSource: state.orderDetails.fromSource,
  fromSourceFrist: state.orderDetails.fromSourceFrist,
  fromSourceSecond: state.orderDetails.fromSourceSecond,
});

const mapDispatch = dispatch => {
  return {
    addOrder: dispatch.orderDetails.addOrder,
    getMoneyCode: dispatch.orderDetails.getMoneyCode,
  };
};

export default connect(
  mapState,
  mapDispatch
)(Addorder);
